import { render } from "./AddonViewProcessingColor.vue?vue&type=template&id=117e55d4&scoped=true&ts=true"
import script from "./AddonViewProcessingColor.vue?vue&type=script&lang=ts"
export * from "./AddonViewProcessingColor.vue?vue&type=script&lang=ts"

import "./AddonViewProcessingColor.vue?vue&type=style&index=0&id=117e55d4&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-117e55d4"]])

export default __exports__